// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  restaurantId: __t.u64().name("restaurant_id"),
  atMicros: __t.i64().name("at_micros"),
  ownerOnline: __t.bool().name("owner_online"),
  cloudMoneyCents: __t.i64().name("cloud_money_cents"),
  dailyServed: __t.u32().name("daily_served"),
  dailyLost: __t.u32().name("daily_lost"),
  guestsJson: __t.string().name("guests_json"),
  staffJson: __t.string().name("staff_json"),
});
